import React from 'react'
import ReactDOM from 'react-dom'
import App from 'App'
import { captureLoginLink } from 'services/login-link'
import '@ui/css/balloon.css'
import '@ui/css/_reset.css'
import '@ui/css/fonts.css'
import '@ui/css/circle-progressbar.css'

// a login link token has to leave the address bar before the router or
// anything else gets to look at the URL
captureLoginLink()

ReactDOM.render(<App/>, document.getElementById('root'))
